var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-toolbar',{staticClass:"md-transparent",class:{
    'md-toolbar-absolute md-white md-fixed-top': _vm.$route.meta.navbarAbsolute,
  },attrs:{"md-elevation":"0"}},[_c('div',{staticClass:"md-toolbar-row"},[_c('div',{staticClass:"md-toolbar-section-start"},[_c('h3',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$route.name)+" - "+_vm._s(_vm.groupSelected.toUpperCase()))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }